<template>
  <div>
    <v-sheet tile height="54" class="d-flex">
      <v-btn icon @click="$refs.calendar.prev()">
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
      <v-subheader v-if="$refs.calendar">{{
        $refs.calendar.title
      }}</v-subheader>
      <v-spacer />
      <v-select
        v-model="type"
        :items="types"
        dense
        outlined
        hide-details
        label="type"
      ></v-select>
      <v-select
        class="ml-2 ml-lg-5"
        v-model="teacher"
        :items="teachers"
        dense
        outlined
        hide-details
        item-value="id"
        item-text="name"
        return-object
        label="Teacher"
        @change="timestamp = Date.now()"
      ></v-select>
      <v-switch class="ml-2 ml-lg-5 ma-auto" @change="timestamp = Date.now()" v-model="onlineOnly" label="Online Only"/>
      <!-- <v-checkbox @click="timestamp = Date.now()" class="ml-5 pa-0"  :value="true" v-model="unfiltered" label="Show unfiltered availabilities"/> -->
      <v-spacer />
      <v-btn icon @click="$refs.calendar.next()">
        <v-icon>mdi-chevron-right</v-icon>
      </v-btn>
    </v-sheet>
    <v-sheet height="600">
      <v-calendar
        ref="calendar"
        v-model="value"
        :type="type"
        :events="events"
        :event-overlap-threshold="30"
        :event-color="getEventColor"
        :first-time="minDayTime"
        @change="getEvents"
        @click:event="showEvent"
        @click:more="viewDay"
        @click:date="viewDay"
        :key="timestamp"
      ></v-calendar>
      <v-menu
        v-model="selectedOpen"
        :close-on-content-click="false"
        :activator="selectedElement"
        offset-x
      >
        <v-card color="grey lighten-4" min-width="350px" flat>
          <v-toolbar :color="selectedEvent.color" dark>
            <v-toolbar-title>
              {{ selectedEvent.name }} - {{ selectedEvent.start | formatDate }}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon v-bind="attrs" v-on="on">
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <v-card class="mx-auto" max-width="400" width="200" tile>
                <v-list dense>
                  <v-list-item-group color="primary">
                    <v-list-item
                      :to="{
                        name: 'Teacher',
                        params: {
                          id: selectedEvent.id,
                          tab: 'tab-availability',
                        },
                      }"
                    >
                      <v-list-item-icon class="mr-2">
                        <v-icon>mdi-clock-outline</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title
                          >View Availabilities</v-list-item-title
                        >
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item
                      v-if="selectedEvent.data"
                      :to="{
                        name: 'TeacherAvailability',
                        params: {
                          teacherId: selectedEvent.id,
                          id: selectedEvent.data.availabilityId,
                        },
                      }"
                    >
                      <v-list-item-icon class="mr-2">
                        <v-icon>mdi-pencil-outline</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title>Edit Availability</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-card>
            </v-menu>
          </v-toolbar>
          <v-card-text>
            <v-simple-table>
              <tbody>
                <tr v-if="selectedTeacher.email">
                  <td>Email</td>
                  <td>{{ selectedTeacher.email }}</td>
                </tr>
                <tr v-if="selectedTeacher.phone">
                  <td>Phone</td>
                  <td>
                    <the-mask
                      mask="+1(###) ###-####"
                      v-model="selectedTeacher.phone"
                    />
                  </td>
                </tr>
                <tr>
                  <td>Available</td>
                  <td>
                    {{ selectedEvent.start | formatTime }} -
                    {{ selectedEvent.end | formatTime }}
                  </td>
                </tr>
                <tr>
                  <td>Schedule</td>
                  <td>
                    <div
                      class="my-2"
                      v-if="
                        selectedTeacherSchedules &&
                        selectedTeacherSchedules.length > 0
                      "
                    >
                      <div
                        v-for="schedule in selectedTeacherSchedules"
                        :key="schedule.id"
                      >
                        <router-link
                          :to="{
                            name: 'CourseDetail',
                            params: {
                              id: schedule.course.id,
                              tab: 'tab-schedule',
                            },
                          }"
                        >
                          {{ schedule.course.name }}
                          {{ schedule.startTime | formatTimeOnly }} -
                          {{ schedule.endTime | formatTimeOnly }}
                        </router-link>
                      </div>
                    </div>
                    <span v-else>Not scheduled on this date</span>
                  </td>
                </tr>
                <tr>
                  <td>About</td>
                  <td>
                    <div class="my-2" style="white-space: pre-line;">{{ selectedTeacher.about }}</div>
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
            <div class="text-caption my-2" v-if="availabilityInfo">
              {{ selectedEvent.name }}'s availability was last updated on {{availabilityInfo.lastUpdatedOn | formatDateTimeUTC}}
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer/>
            <v-btn text color="secondary" @click="selectedOpen = false">
              Close
            </v-btn>
            <v-spacer/>
          </v-card-actions>
        </v-card>
      </v-menu>
      <v-dialog
        v-model="selectedOpenMore"
        :close-on-content-click="false"
        offset-x
      >
        <v-card color="grey lighten-4" min-width="350px" flat>
          <v-toolbar>
            <v-toolbar-title>{{
              selectedMoreDate | formatDate
            }}</v-toolbar-title>
          </v-toolbar>
          <v-card-text> More events... </v-card-text>
          <v-card-actions>
            <v-btn text color="secondary" @click="selectedOpenMore = false">
              Cancel
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-sheet>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import { TheMask } from "vue-the-mask";

export default {
  data: () => ({
    focus: "",
    timestamp: Date.now(),
    unfiltered: false,
    type: "day",
    types: ["month", "week", "day"],
    selectedEvent: {},
    selectedTeacher: {},
    onlineOnly: true,
    selectedTeacherSchedules: [],
    selectedElement: null,
    selectedOpen: false,
    selectedOpenMore: false,
    selectedMoreDate: null,
    availabilityInfo: null,
    minDayTime: "08:00",
    value: "",
    events: [],
    teachers: [],
    teacher: null,
    colors: [
      "blue",
      "indigo",
      "deep-purple",
      "cyan",
      "green",
      "orange",
      "grey darken-1",
    ],
    names: [
      "Meeting",
      "Holiday",
      "PTO",
      "Travel",
      "Event",
      "Birthday",
      "Conference",
      "Party",
    ],
  }),
  components: {
    TheMask,
  },
  computed: {
    ...mapGetters(["currentUser", "isAppLoading"]),
  },
  mounted() {
    console.log("Mounted schedules component");
  },
  filters: {
    formatDate(value) {
      return moment(value).format("ddd, MMM DD YYYY");
    },
    formatTime(value) {
      return moment(value).format("h:mm a");
    },
    formatTimeOnly(value) {
      return moment(value, "HH:mm").format("h:mm a");
    },
    formatDateTimeUTC(value) {
      return moment.utc(value).local().format("ddd, MMM DD YYYY h:mm a");
    },
  },
  methods: {
    viewDay({ date }) {
      this.focus = date;
      this.type = "day";
    },
    showMore(obj) {
      const open = () => {
        this.selectedMoreDate = obj.date;
        setTimeout(() => {
          this.selectedOpenMore = true;
        }, 10);
      };

      if (this.selectedOpen) {
        this.selectedOpenMore = false;
        setTimeout(open, 10);
      } else {
        open();
      }
    },
    initTeacher(teacherId) {
      if (teacherId) {
        this.$axios
          .get("teacher/getById", { params: { teacherId: teacherId } })
          .then((resp) => {
            this.selectedTeacher = resp.data.data;
          });
      }
    },
    showEvent({ nativeEvent, event }) {
      const teacherId = event.id;
      this.initTeacher(teacherId);

      const open = () => {
        this.selectedEvent = event;
        this.selectedElement = nativeEvent.target;
        //get teacher's schedule
        const date = moment(event.start).format("YYYY-MM-DD");
        const params = { teacherId: event.id, date };
        this.$axios
          .get("/teacher/get-date-schedules", { params })
          .then((resp) => {
            this.selectedTeacherSchedules = resp.data.data;
          });

        this.$axios.get('/teachers/availability/last-updated-on', {params})
          .then((resp) => {
            this.availabilityInfo = resp.data.data;
          });

        setTimeout(() => {
          this.selectedOpen = true;
        }, 10);
      };

      if (this.selectedOpen) {
        this.selectedOpen = false;
        setTimeout(open, 10);
      } else {
        open();
      }

      nativeEvent.stopPropagation();
    },
    async loadUnfilteredAvailabilities( min, max ) {
      //get teachers schedules
      const params = {
        teacherIds: null,
        startDate: min,
        endDate: max,
      };

      return this.$axios
        .get("/teachers/availability/schedules", { params })
        .then((resp) => {
          const events = resp.data.data;

          let teachers = new Set();
          events.forEach((e) => {
            teachers.add(e.name);
          });
          teachers = [...teachers];

          //format to Calendar Event objects
          return events.map((e) => {
            const colorIndex =
              teachers.findIndex((n) => n == e.name) % this.colors.length;
            return {
              id: e.id,
              name: e.name,
              start: moment(e.start).format("YYYY-MM-DD HH:mm"),
              end: moment(e.end).format("YYYY-MM-DD HH:mm"),
              color: this.colors[colorIndex],
              data: e.data,
            };
          });
        });
    },
    getEvents({ start, end }) {
      const minDate = moment(start.date);
      const maxDate = moment(end.date);
      const min = minDate.format("YYYY-MM-DD");
      const max = maxDate.format("YYYY-MM-DD");

      if(this.unfiltered){
        this.loadUnfilteredAvailabilities(min, max)
          .then( (events) => {
            this.events = events;
            this.calculateMinTime();
          });
      }
      else{
        this.loadTeachersAvailabilities(min, max)
          .then( (events) => {
            this.events = events;

            this.calculateMinTime();

            this.loadTeachers(minDate, maxDate)
              .then((teachers) => {
                const paddedTeachers = teachers.map((t) => {
                  t.name = `${t.firstName} ${t.lastName}`;
                  return t;
                });
                const allTeacher = { id: null, name: "All Teachers" };
                paddedTeachers.sort((t1, t2) => (t1.firstName > t2.firstName ? 1 : -1));
                this.teachers = [allTeacher, ...paddedTeachers];
              });
          });
      }
    },
    async loadTeachers(minDate, maxDate) {
      const params = {
        startDate: minDate.format("YYYY-MM-DD"),
        endDate: maxDate.format("YYYY-MM-DD"),
      };
      return await this.$axios
        .get("/teacher/allocated-teachers-by-date", { params })
        .then((resp) => {
          const teachers = resp.data.data;
          return teachers;
        });
    },
    async loadTeachersAvailabilities(min, max) {
      const params = {
        startDate: min,
        endDate: max,
        onlineOnly: this.onlineOnly,
        teacherId: this.teacher && this.teacher.id ? this.teacher.id:null
      };

      return this.$axios
        .get("/teacher/available-teachers-by-date", { params })
        .then((resp) => {
          const teacherSlots = resp.data.data;
          let events = [];
          teacherSlots.forEach((t, index) => {
            const date2Times = t.availableTimeSlots;
            const dates = Object.keys(date2Times);
            dates.forEach((d) => {
              const timeslots = date2Times[d];

              timeslots.forEach((times) => {
                const colorIndex = index % this.colors.length;
                const color = t.color ? t.color:this.colors[colorIndex];
                const start = this.getTimeFromMins(times[0])
                const end = this.getTimeFromMins(times[1])
                const startDateTime = `${d} ${start}`;
                const endDateTime = `${d} ${end}`;
                const e = {
                  id: t.id,
                  name: `${t.firstName} ${t.lastName}`,
                  start: startDateTime,
                  end: endDateTime,
                  color: color,
                };

                events.push(e);
              });
            });
          });

          return events;
        });
    },
    calculateMinTime(){
      // return '08:00'; //Temporary hard code; this events returned from server isn't accurate

      // find min hours
      if (this.type === "day" && this.events && this.events.length > 0) {
        const minTime = this.events.reduce(
          (min, e) =>
            moment(e.start).isSameOrBefore(min) ? moment(e.start) : min,
          moment(this.events[0].start)
        );
        this.minDayTime = minTime.format("HH:mm");
      }
    },
    getTimeFromMins(mins) {
      // do not include the first validation check if you want, for example,
      // getTimeFromMins(1530) to equal getTimeFromMins(90) (i.e. mins rollover)
      if (mins >= 24 * 60 || mins < 0) {
        throw new RangeError(
          "Valid input should be greater than or equal to 0 and less than 1440."
        );
      }
      var h = (mins / 60) | 0,
        m = mins % 60 | 0;
      return moment.utc().hours(h).minutes(m).format("HH:mm");
    },
    getEventColor(event) {
      return event.color;
    },
  },
};
</script>